import { createContext, useContext, useState, useCallback, useEffect } from 'react';

interface NavbarContextValue {
  darkHero: boolean;
  setDarkHero: (v: boolean) => void;
}

const NavbarContext = createContext<NavbarContextValue>({
  darkHero: false,
  setDarkHero: () => {},
});

export function NavbarProvider({ children }: { children: React.ReactNode }) {
  const [darkHero, setDarkHeroState] = useState(false);
  const setDarkHero = useCallback((v: boolean) => setDarkHeroState(v), []);
  return (
    <NavbarContext.Provider value={{ darkHero, setDarkHero }}>
      {children}
    </NavbarContext.Provider>
  );
}

export function useNavbar() {
  return useContext(NavbarContext);
}

/** Call at the top of a page to declare whether it has a dark hero */
export function useDarkHero(isDark: boolean) {
  const { setDarkHero } = useNavbar();
  useEffect(() => {
    setDarkHero(isDark);
    return () => setDarkHero(false);
  }, [isDark, setDarkHero]);
}
